<template>
  <b-container data-app fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="fas fa-file-medical"></i>
              {{
                $t("public.views.Pages.Professional.Contact.Petitioner.title")
              }}<span v-if="patientGlobal !== null && patientGlobal.name">
                - {{ patientGlobal.name }} {{ patientGlobal.lastname }} (
                {{ patientGlobal.document }} )
              </span>
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-button v-if="
              checkPermissionProfessional('CONTACT_PETITIONER', ['CREATE'])
            " ref="btnShowNewVisit" class="mr-2" style="right" variant="success" @click="openModal">{{
  $t(
    "public.views.Pages.Professional.Contact.Petitioner.btnCreate"
  )
}}
            </b-button>
            <b-button v-if="patient !== null && patient.name" right variant="primary" @click="backContacts">{{
              $t("generic.btnBack")
            }}
            </b-button>
          </template>
          <template v-if="checkPermissionProfessional('CONTACT_PETITIONER', ['LIST'])" v-slot:body>
            <div class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getPetitionersExcel">
                Excel
              </b-button>
            </div>
            <div>
              <v-card-title>
                <v-text-field v-model="search" hide-details single-line @blur="getAllPetitioner">
                  <template slot="label">
                    <div class="search-datatable">
                      <i class="fas fa-search fa-fw"></i>
                      {{
                        $t(
                          "public.views.Pages.Professional.Contact.Petitioner.search"
                        )
                      }}
                    </div>
                  </template>
                </v-text-field>
                <b-button class="mt-3 ml-2" variant="primary" @click="getAllPetitioner">
                  {{
                    $t(
                      "public.views.Pages.Professional.Contact.Petitioner.search"
                    )
                  }}
                </b-button>
              </v-card-title>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="petitioners" :options.sync="pagination" :search="search"
                :server-items-length="total" item-key="id">
                <template v-slot:item.dispensationDate="{ item }">
                  <div v-if="item.dispensationDate">
                    {{ item.dispensationDate | adjustToTimezone("DD/MM/YYYY") }}
                  </div>
                </template>
                <template v-slot:item.professional="{ item }">
                  <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
                    <b-avatar v-bind:src="
                      item.professional.avatarUrl
                        ? item.professional.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">
                        {{ item.professional.name }}
                      </p>
                      <p class="mb-0 font-size-12">
                        {{ item.professional.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.patient="{ item }">
                  <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
                    <b-avatar v-bind:src="
                      item.patient.avatarUrl
                        ? item.patient.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                      <p class="mb-0 font-size-12">
                        {{ item.patient.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.id="{ item }">
                  <div class="div-table-data">
                    <button id="btnSee" class="item" v-on:click="getPetitioner(item.id)">
                      <i class="ri-eye-line"></i>
                    </button>
                    <b-popover placement="botton" target="btnSee" triggers="hover focus">
                      <template #title>{{
                        $t(
                          "public.views.Pages.Professional.Contact.Petitioner.btnSee"
                        )
                      }}
                      </template>
                    </b-popover>
                    <button id="btnDwn" class="item" v-on:click="getPetitionerPdf(item.id)">
                      <i class="ri-file-download-line"></i>
                    </button>
                    <b-popover placement="botton" target="btnDwn" triggers="hover focus">
                      <template #title>{{
                        $t(
                          "public.views.Pages.Professional.Contact.Petitioner.btnDwn"
                        )
                      }}
                      </template>
                    </b-popover>
                    <button v-if="
                      checkPermissionProfessional('CONTACT_PETITIONER', [
                        'EDIT',
                      ])
                    " id="btnSend" class="item" v-on:click="sendPetitioner(item.id)">
                      <i class="ri-mail-send-line"></i>
                    </button>
                    <b-popover v-if="
                      checkPermissionProfessional('CONTACT_PETITIONER', [
                        'EDIT',
                      ])
                    " placement="botton" target="btnSend" triggers="hover focus">
                      <template #title>{{
                        $t(
                          "public.views.Pages.Professional.Contact.Petitioner.btnSend"
                        )
                      }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
              <b-modal id="modal-new-petitioner" centered size="lg" @ok="saveFormStep1">
                <template #modal-title>{{
                  $t(
                    "public.views.Pages.Professional.Contact.Petitioner.modalCreate.title"
                  )
                }}
                </template>
                <template #modal-ok>{{
                  $t(
                    "public.views.Pages.Professional.Contact.Petitioner.modalCreate.save"
                  )
                }}
                </template>
                <template #modal-cancel>{{
                  $t(
                    "public.views.Pages.Professional.Contact.Petitioner.modalCreate.close"
                  )
                }}
                </template>
                <form action="#">
                  <b-form-group label-for="patient">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Petitioner.modalCreate.patient"
                      )
                    }}: *
                    </template>
                    <multiselect v-model="patient" :clear-on-select="false" :close-on-select="false" :disabled="disabled"
                      :internal-search="false" :loading="isLoadingPatients" :multiple="false" :options="patientSelect"
                      :preselect-first="true" :preserve-search="true" label="text" track-by="value" v-bind:class="{
                        'text-danger': isFormPatientErrors,
                        'is-invalid': isFormPatientErrors,
                      }" v-bind:deselectGroupLabel="
  $t(
    'public.views.Pages.Professional.Contact.Petitioner.multiselect.deselectGroupLabel'
  )
" v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Contact.Petitioner.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Contact.Petitioner.multiselect.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Contact.Petitioner.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Contact.Petitioner.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Contact.Petitioner.multiselect.selectedLabel'
  )
" @search-change="getAllPatientsSelect">
                      <template slot="noResult">
                        {{ $t("generic.noResults") }}
                      </template>
                      <template slot="noOptions">
                        {{ $t("generic.min3") }}
                      </template>
                      <template slot="option" slot-scope="props">
                        <b-list-group-item class="d-flex align-items-center">
                          <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                          <span class="mr-auto title-typography-color">{{
                            props.option.text
                          }}</span>
                        </b-list-group-item>
                      </template>
                      <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                          class="multiselect__single">{{ values.length }}
                          {{
                            $t(
                              "public.views.Pages.Professional.Contact.Recipes.selectedOrganizations"
                            )
                          }}</span></template>
                      <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span
                          class="option__desc"><span class="option__title">
                            <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                              class="mr-auto title-typography-color">{{
                                props.option.text
                              }}</span>
                          </span></span></template>
                    </multiselect>
                    <ul v-if="isFormPatientErrors">
                      <li v-for="(error, index) in validatorStep1.getErrors(
                        'patient'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>
                  <b-form-group label-for="petitioner">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Petitioner.modalCreate.petitioner"
                      )
                    }}: *
                    </template>
                    <b-form-textarea id="petitioner" v-model="petitioner" :disabled="disabled" size="lg" v-bind:class="{
                      'text-danger': isFormPetitionerErrors,
                      'is-invalid': isFormPetitionerErrors,
                    }" @blur="checkPetitioner(petitioner)"></b-form-textarea>
                    <ul v-if="isFormPetitionerErrors">
                      <li v-for="(error, index) in validatorStep1.getErrors(
                        'petitioner'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>
                  <b-form-group label-for="dispensationDate">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Petitioner.modalCreate.dispensationDate"
                      )
                    }}:
                    </template>
                    <b-form-input id="dispensationDate" v-model="dispensationDate" :disabled="disabled" type="date"
                      v-bind:class="{
                        'text-danger': isFormDispensationDateErrors,
                        'is-invalid': isFormDispensationDateErrors,
                      }" @blur="checkDispensationDate(dispensationDate)"></b-form-input>
                  </b-form-group>
                  <ul v-if="isFormDispensationDateErrors">
                    <li v-for="(error, index) in validatorStep1.getErrors(
                      'dispensationDate'
                    )" v-bind:key="index" class="form-text text-danger">
                      &nbsp;{{ error }}
                    </li>
                  </ul>
                </form>
              </b-modal>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import validator from "vue-m-validator";
import moment from "moment";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import patientService from "../../../../services/patient";
import professionalService from "../../../../services/professional";
import petitionerService from "../../../../services/petitioner";
import utilsService from "../../../../services/utils";

export default {
  name: "Petitioner",
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllPetitioner();
        }
        this.start = true;
      },
    },
  },
  mounted() {
    xray.index();
    this.getProfessional();

    this.getAllPetitioner();

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_PETITIONERS", info: "" });
  },
  computed: {
    isFormDispensationDateErrors() {
      let errors = this.validatorStep1.getErrors("dispensationDate");
      return errors && errors.length > 0;
    },
    isFormPatientErrors() {
      let errors = this.validatorStep1.getErrors("patient");
      return errors && errors.length > 0;
    },
    isFormPetitionerErrors() {
      let errors = this.validatorStep1.getErrors("petitioner");
      return errors && errors.length > 0;
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    getPetitionersExcel() {
      utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_PETITIONERS_EXCEL", info: "" });
      if (this.search) {
        var objectUrl =
          process.env.VUE_APP_BASE_URL_CORE +
          "auth/petitioners/excel?filter=" +
          this.search +
          "&token=" +
          localStorage.getItem("authorization");
      } else {
        var objectUrl =
          process.env.VUE_APP_BASE_URL_CORE +
          "auth/petitioners/excel?token=" +
          localStorage.getItem("authorization");
      }
      window.open(objectUrl);
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    backContacts() {
      this.$router.push({
        name: "auth.professional.contact.contacts",
      });
    },
    async getAllPetitionerPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.getAllPetitioners(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          id
        ),
        (response) => {
          if (response) {
            self.petitioners = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllPetitioners",
            module: "view-pages-professional-contact-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              id: id
            })
          });
        }
      );
    },
    async getPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(id),
        (response) => {
          if (response) {
            self.patientGlobal = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "view-pages-professional-contact-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        }
      );
    },
    createPetitioner() {
      let self = this;

      var data = {
        patient: this.patient.value,
        petitioner: this.petitioner,
        dispensationDate: this.dispensationDate
          ? moment(this.dispensationDate)
          : "",
      };

      this.$awn.asyncBlock(
        petitionerService.create(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PETITIONERS", info: "" });
            this.$bvModal.hide("modal-new-petitioner");
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.Petitioner.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.Petitioner.notification.descCreated"
              ),
              type: "success",
            });
            this.getAllPetitioner();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "petitionerService.create",
            module: "view-pages-professional-contact-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    async getAllPetitioner() {
      let self = this;

      let filter = {
        filter: this.search,
      };

      this.$awn.asyncBlock(
        petitionerService.getAll(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          filter
        ),
        (response) => {
          if (response) {
            self.petitioners = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "petitionerService.getAll",
            module: "view-pages-professional-contact-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              filter: filter
            })
          });
        },
        " "
      );
    },
    getPetitioner(id) {
      let self = this;
      this.$awn.asyncBlock(
        petitionerService.get(id),
        (response) => {
          if (response) {
            self.disabled = true;

            self.patient = self.patientSelect.find(
              (option) => option.value === response.data.patient.id
            );

            self.petitioner = response.data.petitioner;
            self.dispensationDate = response.data.dispensationDate;

            self.$bvModal.show("modal-new-petitioner");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "petitionerService.get",
            module: "view-pages-professional-contact-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    async getAllPatientsSelect(query) {
      let self = this;

      if (query.length > 2) {
        this.isLoadingPatients = true;

        patientService
          .getAll(query)
          .then((response) => {
            if (response) {
              let patientSelect = [];
              response.data.forEach(function (item) {
                patientSelect.push({
                  avatar: item.avatarUrl
                    ? item.avatarUrl +
                    "/" +
                    localStorage.getItem("authorization")
                    : "",
                  text:
                    item.name +
                    " " +
                    item.lastname +
                    " (" +
                    item.document +
                    ") ",
                  value: item.id,
                });
              });
              self.patientSelect = patientSelect;
              self.isLoadingPatients = false;
            }
          })
          .catch((error) => {
            utilsService.auditErrorFrontent({
              info: "patientService.getAll",
              module: "view-pages-professional-contact-petitioner",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                query: query
              })
            });
            self.isLoadingPatients = false;
          });
      }
    },
    sendPetitioner(id) {
      if (this.professional.uuidSignature) {
        let self = this;

        this.$awn.asyncBlock(
          petitionerService.send(id),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PETITIONERS_SEND", info: "" });
              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Petitioner.notification.title"
                ),
                text: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Petitioner.notification.descSend"
                ),
                type: "success",
              });
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "petitionerService.send",
              module: "view-pages-professional-contact-petitioner",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                id: id
              })
            });
          },
          " "
        );
      } else {
        this.$swal({
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.send.title"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.send.content"
          ),
          type: "warning",
          showCancelButton: false,
          confirmButtonText: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.send.btnGo"
          ),
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "auth.professional.account",
            });
          }
        });
      }
    },
    async getProfessional() {
      let self = this;

      professionalService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.professional = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.get",
            module: "view-pages-professional-contact-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        });
    },
    getPetitionerPdf(id) {
      if (this.professional.uuidSignature) {
        let self = this;

        this.$awn.asyncBlock(
          petitionerService.getPdf(id),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PETITIONERS_PDF", info: "" });
              var byteCharacters = atob(response.data.data);
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);
              var file = new Blob([byteArray], {
                type: "application/pdf;base64",
              });
              var fileURL = URL.createObjectURL(file);

              var fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute("download", "peticion.pdf");
              document.body.appendChild(fileLink);

              fileLink.click();

              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Petitioner.notification.title"
                ),
                text: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Petitioner.notification.descCreated"
                ),
                type: "success",
              });
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "petitionerService.getPdf",
              module: "view-pages-professional-contact-petitioner",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                id: id
              })
            });
          },
          " "
        );
      } else {
        this.$swal({
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.generate.title"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.generate.content"
          ),
          type: "warning",
          showCancelButton: false,
          confirmButtonText: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.generate.btnGo"
          ),
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "auth.professional.account",
            });
          }
        });
      }
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkPatient(_patient) {
      const PATIENT = _patient;
      const RULE_1 = {
        expression: !PATIENT.value,
        name: "patient",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Petitioner.errors.erPatient"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkDispensationDate(_dispensationDate) {
      const DATE = _dispensationDate.trim();
      const RULE_1 = {
        expression: !DATE || DATE === "",
        name: "dispensationDate",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Petitioner.errors.erDispensationDate"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPetitioner(_petitioner) {
      const PETITIONER = _petitioner.trim();
      const RULE_1 = {
        expression: !PETITIONER || PETITIONER === "",
        name: "petitioner",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Petitioner.errors.erPetitioner"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkFormStep1() {
      this.checkDispensationDate(this.dispensationDate);
      this.checkPatient(this.patient);
      this.checkPetitioner(this.petitioner);
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        //Call service to store data
        this.createPetitioner();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    clearForm() {
      this.patient = {};
      this.petitioner = "";
      this.dispensationDate = "";
    },
    openModal() {
      if (this.professional.uuidSignature) {
        this.disabled = false;
        this.clearForm();
        this.validatorStep1.errors = [];
        this.$bvModal.show("modal-new-petitioner");
      } else {
        this.$swal({
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.send.title"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.send.content"
          ),
          type: "warning",
          showCancelButton: false,
          confirmButtonText: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.alert.signature.send.btnGo"
          ),
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "auth.professional.account",
            });
          }
        });
      }
    },
  },
  data() {
    return {
      start: false,
      total: 0,
      pagination: {},
      patientId: this.$route.query.patientId,

      isLoadingPatients: false,
      //Modal
      patientGlobal: {},
      patient: {},
      petitioner: "",
      dispensationDate: "",

      disabled: false,
      validatorStep1: validator,
      isValidateStep1: false,

      search: "",
      patientSelect: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.headers.patient"
          ),
          align: "start",
          value: "patient",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.headers.professional"
          ),
          align: "start",
          value: "professional",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Petitioner.headers.dispensationDate"
          ),
          value: "dispensationDate",
        },
        { text: "Petición", value: "petitioner" },
        { text: "", value: "id" },
      ],
      petitioners: [],
      //Professional row datatable
      professional: [],
      //Patient object
      patient: {},
    };
  },
  components: {
    Multiselect,
  },
};
</script>
